module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/banner/zh-hant-49f8839876ae5276cba47dc1590b9e0d.jpg";